import Styled from 'styled-components'

export const Brand = Styled.h1`
`

export const Banner = Styled.div`
`

export const CotainerProduct = Styled.div`
`

export const Cashback = Styled.div`
`
export const Space = Styled.div`
`

export const SearchResultText = Styled.span`
  font-weight: bold;
  font-size: ${props => props.hasDidYouMean ? '13px' : '14px'};
`;

export const DidYouMeanText = Styled.span`
  font-weight: bold;
  font-size: 14px;
`;

/* Desktop: alinha o Container do Bootstrap ao padrão do header (1320/32) */
export const PageWrap = Styled.div`
  @media (min-width: 1024px) {
    .container {
      max-width: 1320px;
      padding-left: 32px;
      padding-right: 32px;
    }
  }
`;

/* Desktop: busca em 2 colunas (filtros 280px + produtos) */
export const ListingLayout = Styled.div`
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 280px minmax(0, 1fr);
    gap: 32px;
    align-items: start;

    .product-grid {
      margin-left: 0;
      margin-right: 0;
    }
    .product-grid .col-6 {
      flex: 0 0 25%;
      max-width: 25%;
      width: 25%;
    }

    ${({ $isEmptySearch }) => $isEmptySearch && `
      display: block;
    `}
  }
`;

/* Estado vazio da busca sem resultados */
export const EmptySearchWrap = Styled.div`
  width: 100%;
  padding-top: clamp(2rem, 12vw, 4rem);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const EmptySearchContent = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
`;

export const EmptySearchImg = Styled.img`
  width: clamp(4rem, 22vw, 4.75rem);
  aspect-ratio: 76 / 84;
  max-width: 100%;
  object-fit: contain;
`;

export const EmptySearchTitle = Styled.h6`
  width: min(100%, 15rem);
  margin: 0;
  color: var(--primary-color);
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
`;

export const EmptySearchButton = Styled.button`
  width: min(85%, 15rem);
  height: auto;
  min-height: clamp(2.75rem, 12vw, 2.875rem);
  margin-top: 1.5rem;
  padding: clamp(0.5rem, 2vw, 0.75rem) clamp(1rem, 6vw, 1.5rem);
  border-radius: 10px;
  box-sizing: border-box;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(0.5rem, 3vw, 0.75rem);
`;
